import styled from "styled-components"

export const FeedWidgetContainer = styled.div`
  width: 100%;
`
